<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Base de données médicamenteuse (Synapse-Medicine) </div>
        <div class="modal-body">
            <div class="all-container">
                <div class="search-result-container">
                    <div class="search">
                        <frg-search-input (search)="onSearchMedicament($event)"></frg-search-input>
                    </div>
                    <div class="result-elem" *ngFor="let medic of resultatRechercheSynapse"
                        [ngClass]="{'active': isInSelectEntities(medic)}">
                        <div class="medic-name" (click)="selectMedic(medic)">
                            {{medic.entity.label}}
                        </div>
                        <div class="favorite" [ngClass]="{'none': !isFavoriteMedic(medic)}"
                            (mousedown)="toggleFavMedic(medic)"></div>
                    </div>
                    <div *ngIf="!resultatRechercheSynapse || resultatRechercheSynapse.length === 0">
                        Aucune spécialité médicamenteuse trouvée. Veuillez saisir ou modifier la recherche.
                    </div>
                </div>
                <div class="synpase-widgets">

                    <div #synapseProfile id="synapseProfile" class="synapse-profile"></div>
                    <div #synapsePosology id="synapsePosology" class="synapse-posology"></div>
                    <div #synapseInteract id="synapseInteract" class="synapse-interact"></div>
                    <div #synapseGrounds id="synapseGrounds" class="synapse-grounds"></div>
                    <div #synapseAdverses id="synapseAdverses" class="synapse-adverses"></div>
                </div>
            </div>
            <div class="button-wrapper">
                <frg-button (activated)="closeAddEditModal()" [backgroundColor]="'var(--darkest-primary)'">{{ preview ?
                    'Fermer' : 'Annuler' }}
                </frg-button>
                <frg-button (activated)="insertionOrdonnance()" [disabled]="selectListOfMedic.length === 0"
                    [backgroundColor]="'var(--darkest-primary)'" *ngIf="!preview">
                    Insérer</frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>